import { FaqContainer } from "@/components/faq/FaqContainer";
import { FaqItem } from "@/components/faq/FaqItem";
import { TextLink } from "@/components/links/TextLink";
import { Heading4 } from "@/components/text/Heading4";
import { minutesFree } from "@/constants/payment";

export function PricingFaq() {
  return (
    <>
      <Heading4 elementType="h2" className="mx-auto mb-1 mt-16 max-w-4xl">
        FAQ
      </Heading4>
      <FaqContainer>
        <FaqItem question="What is conversion time?">
          Conversion time is the amount of audio you can convert using Audimee's
          or your custom voice models. Free accounts allow up to {minutesFree}{" "}
          minutes of audio conversion. After reaching this limit, you can
          subscribe to a paid plan to continue converting.
        </FaqItem>

        <FaqItem question="How do I get more conversion time?">
          For users on a paid plan, your conversion time is refilled every
          month. This refill is based on the date of your subscription
          initiation. To find out when your conversion time will refill, visit
          your{" "}
          <TextLink href="/account" className="text-base" external={false}>
            account
          </TextLink>{" "}
          page. Unused conversion time rolls over to the next month. If you
          cancel your subscription, any conversion time you have saved up will
          be lost (at the end of the billing period). If you change your
          subscription, your conversion time will be reset to the new plan's
          limit.
        </FaqItem>

        <FaqItem question="Commercial use after cancelling my subscription?">
          Cancelling your paid plan does not void the commercial rights to the
          created material. It is yours to use as you wish, regardless of future
          subscriptions.
        </FaqItem>

        <FaqItem question="How do I manage my subscription?">
          Navigate to your{" "}
          <TextLink href="/account" className="text-base" external={false}>
            account
          </TextLink>{" "}
          page. Here, you can cancel your subscription, update payment
          information, view your payment history, and more.
        </FaqItem>

        <FaqItem question="What happens to my bill if I switch plans?">
          When you switch to a different subscription plan, we apply proration
          to adjust your billing. Proration means we calculate your bill based
          on how much time you spent on each plan during the billing cycle. This
          ensures that you only pay for the time you spent on each plan.
        </FaqItem>

        <FaqItem question="What happens if I cancel my subscription?">
          You will retain access to all additional features until the end of
          your current billing period. After the billing period ends, your
          account will revert to the free plan limitations and any conversion
          time you have saved up will be lost.
        </FaqItem>

        <FaqItem question="What are custom voice model slots?">
          Custom voice model slots are the number of your own trained vocal
          models that you can keep saved. The custom voice model slots can be
          retrained.
        </FaqItem>
      </FaqContainer>
    </>
  );
}
